var _rect, _path, _path2, _path3, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgJcb(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 24,
    viewBox: "0 0 35 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 34,
    height: 23,
    rx: 3.5,
    fill: "white",
    stroke: "#D9D9D9"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.3181 12.2873C22.8318 12.2984 23.3484 12.2646 23.86 12.3049C24.3781 12.4015 24.503 13.1859 24.0427 13.4428C23.7286 13.612 23.3555 13.5058 23.015 13.5357H22.3181V12.2873ZM24.157 10.8743C24.2711 11.2771 23.8828 11.6388 23.4948 11.5833H22.3181C22.3263 11.2034 22.302 10.7911 22.33 10.4312C22.8014 10.4445 23.2772 10.4041 23.7459 10.4523C23.9472 10.5029 24.1158 10.6684 24.157 10.8743ZM26.989 4.90042C27.0108 5.66972 26.9921 6.47968 26.9984 7.26459C26.997 10.4557 27.0015 13.6468 26.9959 16.8381C26.9752 18.0341 25.9153 19.0733 24.7277 19.0971C23.5388 19.102 22.3498 19.0979 21.1608 19.0992V14.2749C22.4563 14.2682 23.7524 14.2884 25.0474 14.2647C25.6481 14.227 26.3061 13.8307 26.334 13.1696C26.4048 12.5057 25.7788 12.0464 25.1845 11.9739C24.9561 11.968 24.9627 11.9073 25.1845 11.8808C25.7513 11.7583 26.1964 11.1717 26.0297 10.5841C25.8876 9.96618 25.2045 9.72701 24.6364 9.72819C23.4781 9.72032 22.3195 9.72709 21.1611 9.72481C21.1686 8.82416 21.1455 7.92255 21.1735 7.02256C21.2653 5.84819 22.3519 4.87971 23.5229 4.90073C24.6784 4.90055 25.8337 4.90055 26.989 4.90051V4.90042Z",
    fill: "url(#paint0_linear_36526_46015)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.07085 7.14441C8.10043 5.95034 9.16487 4.91967 10.351 4.90222C11.5355 4.89857 12.7201 4.90169 13.9045 4.90064C13.9013 8.89572 13.9109 12.8912 13.8996 16.8861C13.854 18.0657 12.8012 19.0767 11.6279 19.0976C10.4413 19.1019 9.25445 19.0982 8.06773 19.0994V14.1124C9.22043 14.3847 10.4292 14.5006 11.6052 14.32C12.3081 14.2069 13.0772 13.8617 13.3152 13.1324C13.4903 12.5086 13.3917 11.8521 13.4178 11.2119V9.72503H11.3827C11.3735 10.7084 11.4014 11.6935 11.3679 12.6757C11.3131 13.2794 10.7152 13.663 10.1458 13.6425C9.43969 13.65 8.04039 13.1307 8.04039 13.1307C8.03687 11.2883 8.06087 8.98091 8.07085 7.14458V7.14441Z",
    fill: "url(#paint1_linear_36526_46015)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14.6631 10.325C14.5559 10.3477 14.6415 9.96009 14.6141 9.81305C14.6214 8.88335 14.5989 7.95263 14.6266 7.02359C14.7181 5.84425 15.813 4.87336 16.9888 4.90097H20.4512C20.4479 8.89605 20.4576 12.8916 20.4463 16.8864C20.4006 18.066 19.3477 19.077 18.1745 19.0979C16.9878 19.1024 15.8009 19.0986 14.6141 19.0997V13.6358C15.4246 14.3009 16.5262 14.4044 17.536 14.4062C18.2973 14.4059 19.0541 14.2885 19.7934 14.113V13.112C18.9602 13.5272 17.9809 13.7909 17.0573 13.5524C16.4131 13.392 15.9454 12.7694 15.9559 12.1046C15.8812 11.4131 16.2865 10.6832 16.9659 10.4776C17.8095 10.2135 18.7289 10.4155 19.5197 10.7589C19.6891 10.8476 19.8611 10.9576 19.7933 10.6744V9.88764C18.4708 9.573 17.0634 9.45721 15.7348 9.79951C15.3502 9.908 14.9755 10.0725 14.6631 10.3251V10.325Z",
    fill: "url(#paint2_linear_36526_46015)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_36526_46015",
    x1: 21.121,
    y1: 11.6962,
    x2: 26.9616,
    y2: 11.6962,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#58B03A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#55B330"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_36526_46015",
    x1: 7.94354,
    y1: 12.136,
    x2: 13.8088,
    y2: 12.136,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0F6EB6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#006DBA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_36526_46015",
    x1: 14.6055,
    y1: 11.8343,
    x2: 20.4501,
    y2: 11.8343,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DE0D3D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E30138"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgJcb);
export default __webpack_public_path__ + "static/media/JCB.6690e9d030ba06f416c1f0d5e9bd343f.svg";
export { ForwardRef as ReactComponent };